module.exports = __webpack_public_path__ + "img/ezra-claytan-daniels.766e8dd1.png";